import { service } from '@/utils/request'

export default {
  // 查询导航
  getList() {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/listDetail',
      method: 'get'
    })
  },
  // 导航的增删改
  handleNavigation(data) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/config',
      method: 'post',
      data
    })
  },
  // 导航的banner列表
  bannerList(params) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/banner/listDetail',
      method: 'get',
      params
    })
  },
  // 导航的banner增删改
  handleBanner(data) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/banner/config',
      method: 'post',
      data
    })
  },
  // 金刚位列表
  diamondList(params) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/diamond/listDetail',
      method: 'get',
      params
    })
  },
  // 金刚位增删改
  handleDiamond(data) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/diamond/config',
      method: 'post',
      data
    })
  },
  // 获取卡种
  cardTypeList(params) {
    return service({
      url: '/cloud/uac/vipCardType/selectList',
      method: 'get',
      params
    })
  },
  // 获取导航VIP推荐
  getVipType(params) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/vipRecommend/listDetail',
      method: 'get',
      params
    })
  },
  // 导航VIP推荐增删改
  handleVipType(data) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/vipRecommend/config',
      method: 'post',
      data
    })
  },
  /**运营模块管理 **/
  // 获取运营模块列表
  getModuleList(params) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/module/listDetail',
      method: 'get',
      params
    })
  },
  // 运营模块增删改
  handleModule(data) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/moduele/config',
      method: 'post',
      data
    })
  },
  // 运营模块排序
  sortModule(data) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/module/sort',
      method: 'post',
      data
    })
  },
  // 获取模块下的banner
  findBannerByModuleId(params) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/module/banner/page',
      method: 'get',
      params
    })
  },
  // 根据模块id获取数据
  findListByModuleId(data) {
    return service({
      url: '/cloud/bbs/v1/navigation/operation/module/data/findListByModuleId',
      method: 'post',
      data
    })
  },
  // 添加模块中的数据
  addBusiness(data) {
    return service({
      url: '/cloud/bbs/v1/navigation/operation/module/data/add',
      method: 'post',
      data
    })
  },
  // 修改模块中数据权重
  updateWeight(params) {
    return service({
      url: '/cloud/bbs/v1/navigation/operation/module/data/update/weight',
      method: 'post',
      params
    })
  },
  // 修改模块状态
  updateBusinessStatus(params) {
    return service({
      url: '/cloud/bbs/v1/navigation/operation/module/data/shelves/toggle',
      method: 'post',
      params
    })
  },
  // 修改模块中数据
  updateBusiness(data) {
    return service({
      url: '/cloud/bbs/v1/navigation/operation/module/data/update',
      method: 'post',
      data
    })
  },
  // 删除模块中数据
  deleteBusiness(params) {
    return service({
      url: '/cloud/bbs/v1/navigation/operation/module/data/delete',
      method: 'post',
      params
    })
  },
  // 获取banner列表
  getModuleBannerList(params) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/module/banner/page',
      method: 'get',
      params
    })
  },
  // 增删改模块中的banner
  handleModuleBanner(data) {
    return service({
      url: '/cloud/bbs/v1/backend/navigation/module/banner/config',
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/contentManage/homePage.js